import { Input as InputPrimitive } from "@base-ui/react/input";

import { focusStyles } from "@beweegbaas/ui/lib/focus-styles";
import { cnState } from "@beweegbaas/ui/lib/utils";

function Input({ className, type, ...props }: InputPrimitive.Props) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cnState(
        [
          "squircle supports-squircle:rounded-full",
          `dark:bg-input/30 border-input aria-invalid:ring-destructive/20
          dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive
          dark:aria-invalid:border-destructive/50 file:text-foreground
          placeholder:text-muted-foreground h-9 w-full min-w-0 rounded-md border
          bg-white px-2.5 py-1 text-sm shadow-xs file:inline-flex file:h-7
          file:border-0 file:bg-transparent file:text-sm file:font-medium
          disabled:pointer-events-none disabled:cursor-not-allowed
          disabled:opacity-40 aria-invalid:ring-[3px] md:text-sm`,
          "ring-0 outline-0",
          focusStyles,
        ],
        className,
      )}
      {...props}
    />
  );
}

// Export InputPrimitive for advanced use cases
export { Input, InputPrimitive };
